import _ from 'lodash';
import { CancelToken } from 'axios';
import { OmnitechApi } from '../../api';
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchSkuQuotaMasters(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchSkuQuotaMasters',
    () => source.cancel('fetchSkuQuotaMasters: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'sku_quota_masters',
      method: 'get',
      params,
      type: 'skuQuota',
      CancelToken: source.token,
      arrayFormat: 'brackets'
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      skuQuotaMasters: _.get(data, 'skuQuotaMasters', {}),
      next: _.get(data, 'skuQuotaMastersPagination.nextPage') > page
        ? () => fetchSkuQuotaMasters({
          page: page + 1,
          ...others
        })
        : null,
      all:
        page === 1 && data.skuQuotaMastersPagination.totalPages > 1
          ? () =>
            Promise.all(
              _.times(data.skuQuotaMastersPagination.totalPages - 1, index =>
                fetchSkuQuotaMasters({ ...params, pageCountless: true, page: index + 2 }),
              ),
            )
          : null,
      count: _.get(data, 'skuQuotaMastersPagination.totalCount')
    }))
};
